import { IonContent } from '@ionic/react';
import React from 'react';
import { useFormContext } from 'react-hook-form';

import { amplitudeModule } from '@/modules/amplitude';
import { OnboardingFooter } from '@/pages/Onboarding/components/Footer';
import { OnboardingNavigation } from '@/pages/Onboarding/components/Navigation';
import { useOnboarding } from '@/pages/Onboarding/context';
import { OwnAiTitle } from '@/pages/Onboarding/Layouts/OwnAI/components/Title';
import {
  DominateVoiceItem,
  DominateVoiceList,
} from '@/pages/Onboarding/Layouts/OwnAI_Dominate/components/DominateVoiceItem';
import { VoiceStyleOptionIdType } from '@/pages/Onboarding/options/VoiceStyle/types';
import { getVoiceStyleTitleById } from '@/pages/Onboarding/options/VoiceStyle/utils/getVoiceStyle';
import { VOICE_STYLE_OPTIONS } from '@/pages/Onboarding/options/VoiceStyle/VOICE_STYLE_OPTIONS';
import { OnbOptionType } from '@/pages/Onboarding/types';
import { userService } from '@/services/user';
import { canLogEvents } from '@/utils/canLogEvents';

import { useSummaryPreload } from '../../hooks/useSummaryPreload';
import { LayoutDataType } from '../../types';

import { PageStyles } from './VoiceStyle.styles';

export const ScreenVoiceStyle: React.FC = () => {
  const { preloadSummaryImages } = useSummaryPreload();

  React.useEffect(() => {
    if (canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'VoiceStyle',
      });
    }
  }, []);

  const { wizard } = useOnboarding();

  const form = useFormContext<LayoutDataType>();

  const voiceStyle = form.watch('voice_style');
  const hasSelection = Boolean(voiceStyle);

  const handleSelect = (
    option: OnbOptionType<LayoutDataType['voice_style']>,
  ) => {
    form.setValue('voice_style', option.id);
  };

  const handleNextStep = () => {
    preloadSummaryImages('summary-deep');
    userService.createOrUpdate({
      onboarding_data: {
        voice_style: getVoiceStyleTitleById(voiceStyle),
      },
    });
    wizard.nextStep();
  };

  const getAudioSrc = (id: OnbOptionType<VoiceStyleOptionIdType>['id']) => {
    return `/assets/layout-own-ai-dominate/voice_style/${id}.mp3`;
  };

  return (
    <PageStyles background={'domination'}>
      <OnboardingNavigation />
      <OwnAiTitle>Which tone makes you kneel?</OwnAiTitle>

      <IonContent>
        <DominateVoiceList>
          {VOICE_STYLE_OPTIONS.map((option) => (
            <DominateVoiceItem
              key={option.id}
              isSelected={voiceStyle === option.id}
              onClick={() => handleSelect(option)}
              title={option.title}
              audioSrc={getAudioSrc(option.id)}
            />
          ))}
        </DominateVoiceList>
      </IonContent>

      {hasSelection && (
        <OnboardingFooter
          onContinue={handleNextStep}
          buttonColor={'red-gradient'}
          buttonRadius={'sm'}
          buttonSize={'medium'}
          buttonClassName={'page-footer'}
          buttonText={'I’ll follow'}
        />
      )}
    </PageStyles>
  );
};
